/*====================================================
  HELMET CATEGORY TABS
=====================================================*/

(function () {

  function initHelmetCategoryTabs(section) {

    if (!section) return;

    const tabs = section.querySelectorAll('.helmet-category-tabs__tab');
    const panels = section.querySelectorAll('.helmet-category-tabs__panel');

    if (!tabs.length || !panels.length) return;

    function activate(tabID) {

      tabs.forEach((tab) => {
        tab.classList.remove('is-active');
      });

      panels.forEach((panel) => {
        panel.classList.remove('is-active');
      });

      const activeTab = section.querySelector(
        '.helmet-category-tabs__tab[data-tab="' + tabID + '"]'
      );

      const activePanel = section.querySelector(
        '.helmet-category-tabs__panel[data-panel="' + tabID + '"]'
      );

      if (activeTab) {
        activeTab.classList.add('is-active');
      }

      if (activePanel) {
        activePanel.classList.add('is-active');
      }
    }

    tabs.forEach((tab) => {

      tab.addEventListener('click', function () {

        activate(this.dataset.tab);

      });

    });

  }

  function initAllSections() {

    document.querySelectorAll('.helmet-category-tabs').forEach(function (section) {

      initHelmetCategoryTabs(section);

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initAllSections);

  } else {

    initAllSections();

  }

  document.addEventListener('shopify:section:load', function (event) {

    initHelmetCategoryTabs(event.target);

  });

})();